import * as React from 'react';
import styled from 'styled-components/macro';
import PlusIcon from 'lib/images/PlusIcon';
import { PrimaryButton } from 'lib/components/buttons';
import { theme } from 'lib/style';

interface Props {
  showModal: (params: any) => void;
  color?: string;
}

const NoVideoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  margin-top: 160px;
  height: 24px;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: ${theme.palette.black_1_100};
`;

const CreateButton = styled(PrimaryButton)`
  margin-top: 40px;
  height: 40px;
  font-size: ${theme.fontSizes.m};
  font-weight: 600;
  color: ${theme.palette.white};
  border-radius: 5px;
  background-color: ${props => props.theme.colors.primaryColor};
`;

export const NoAttributes = ({ showModal, color }: Props) => (
  <NoVideoContent>
    <Title>There are no Custom Video Attributes</Title>
    <CreateButton
      text='Create New'
      onClick={showModal}
      icon={<PlusIcon />}
      backgroundColor={color}
    />
  </NoVideoContent>
);
